function createInitialState() {
    const initialState = {
        suggestionsAvailable: false,
        levels: new Array(4).fill({}),
        anyLevelOpen: false,
        showExplanation: true,
        draftCategoryId: 0,
        draftCategoryPath: [],
        previousDraftCategoryId: 0,
        prevoiusDraftCategoryPath: [],
        shortDescriptionForRecommendations: null,
        validationError: null
    };
    initialState.levels = initialState.levels.map((level, index) => {
        level = { index: index };
        level.categories = [];
        level.suggestions = [];
        level.suggestionsVisible = false;
        level.categoriesVisible = false;
        level.moreButtonVisible = false;
        level.hideButtonVisible = false;
        level.selectedCategory = null;
        level.isOpen = false;
        level.visible = true;
        level.disabled = true;
        return level;
    });
    initialState.levels[0].disabled = false;
    return initialState;
}

function validate(newState) {
    newState.validationError =
        !newState.draftCategoryId || newState.draftCategoryId === 0
            ? 'syi_validation_missing_category'
            : null;

    return newState;
}

export default (state, action) => {
    state = state || createInitialState();
    switch (action.type) {
        case 'RESET_CATEGORY': {
            return validate(createInitialState());
        }
        case 'CATEGORIES_LOADING': {
            const newLevels = [...state.levels];
            const newState = { ...state, levels: newLevels };
            newState.levels[action.index].loading = true;
            return validate(newState);
        }
        case 'CATEGORIES_LOADED': {
            const newLevels = [...state.levels];
            const newState = { ...state, levels: newLevels };
            newState.levels[action.index].loading = false;
            newState.levels[
                action.index
            ].categories = action.category.categories.slice();
            newState.levels[
                action.index
            ].suggestions = action.category.suggestions.slice();
            newState.levels[action.index].disabled = false;
            var suggestions =
                newState.levels[action.index].suggestions.length > 0;
            if (suggestions) {
                newState.levels[action.index].suggestionsVisible = true;
                newState.levels[action.index].moreButtonVisible = !newState
                    .levels[action.index].categoriesVisible;
                newState.levels[action.index].hideButtonVisible = !newState
                    .levels[action.index].moreButtonVisible;
                if (action.index === 0) {
                    newState.shortDescriptionForRecommendations =
                        action.shortDescriptionForRecommendations;
                    newState.showExplanation = true;
                }
            } else {
                newState.shortDescriptionForRecommendations = null;
                newState.levels[action.index].suggestionsVisible = false;
                newState.levels[action.index].categoriesVisible = true;
                newState.levels[action.index].moreButtonVisible = false;
                newState.levels[action.index].hideButtonVisible = !newState
                    .levels[action.index].moreButtonVisible;
            }
            return validate(newState);
        }
        case 'OPEN_LEVEL': {
            const newLevels = [...state.levels];
            const newState = { ...state, levels: newLevels };
            newState.anyLevelOpen = true;
            newState.levels[action.index].isOpen = true;
            newState.levels[action.index].disabled = false;
            const suggestions =
                newState.levels[action.index].suggestions.length > 0;
            if (suggestions) {
                newState.levels[action.index].suggestionsVisible = true;
                newState.levels[action.index].moreButtonVisible = !newState
                    .levels[action.index].categoriesVisible;
                newState.levels[action.index].hideButtonVisible = !newState
                    .levels[action.index].moreButtonVisible;
            } else {
                newState.levels[action.index].suggestionsVisible = false;
                newState.levels[action.index].categoriesVisible = true;
                newState.levels[action.index].moreButtonVisible = false;
                newState.levels[action.index].hideButtonVisible = !newState
                    .levels[action.index].moreButtonVisible;
            }
            return validate(newState);
        }
        case 'CLOSE_LEVEL': {
            const newLevels = [...state.levels];
            const newState = { ...state, levels: newLevels };
            newState.anyLevelOpen = false;
            newState.levels[action.index].isOpen = false;
            return newState;
        }
        case 'TOGGLE_CATEGORIES': {
            const newLevels = [...state.levels];
            const newState = { ...state, levels: newLevels };
            newState.levels[action.index].categoriesVisible = action.value;
            newState.levels[action.index].moreButtonVisible = !action.value;
            newState.levels[action.index].hideButtonVisible = action.value;
            return validate(newState);
        }
        case 'SELECT_LEVEL_CATEGORY': {
            const newLevels = [...state.levels];
            const newState = { ...state, levels: newLevels };
            newState.levels[action.index].selectedCategory = action.category;
            if (action.category.isLeaf) {
                newState.showExplanation = false;
            }
            return validate(newState);
        }
        case 'TOGGLE_LEVEL_LABEL': {
            const newLevels = [...state.levels];
            const newState = { ...state, levels: newLevels };
            newState.levels[action.index].visible = action.value;
            return validate(newState);
        }
        case 'DISABLE_LEVEL': {
            const newLevels = [...state.levels];
            const newState = { ...state, levels: newLevels };
            newState.levels[action.index].disabled = true;
            return validate(newState);
        }
        case 'RESET_LEVEL': {
            const newLevels = [...state.levels];
            const newState = { ...state, levels: newLevels };
            newState.levels[action.index].selectedCategory = null;
            newState.levels[action.index].suggestions = [];
            newState.levels[action.index].categories = [];
            if (action.index === 0) {
                newState.showExplanation = true;
            }
            return validate(newState);
        }
        case 'SET_DRAFT_CATEGORY': {
            const newLevels = [...state.levels];
            const newState = {
                ...state,
                draftCategoryId: action.categoryId,
                draftCategoryPath: action.categoryPath,
                previousDraftCategoryId: state.draftCategoryId,
                prevoiusDraftCategoryPath: state.prevoiusDraftCategoryPath,
                levels: newLevels
            };
            return validate(newState);
        }
        default:
            return state;
    }
};
